import { defineStore } from 'pinia'
import axios from 'axios'
import { useRoute, useRouter } from 'vue-router'
import { ref, reactive } from 'vue'

export const usePlanStore = defineStore('PlanStore', {
    state: () => {
        return {
            planData:ref(),
            planCourseData:ref(),
            coursePlan:null,
            plans: null,
            salePlans: reactive({}),
            yearEndPlans: reactive({}),
            isLoading:ref(false),
            route: useRoute(),
            router: useRouter(),
            paymentBtnKey: 1,
            uniqueKeyBtn: 1,
            topUps: {
                'one': {
                    price: 19.99,
                    credit: 20
                },
                'two': {
                    price: 49.99,
                    credit: 50
                },
                'three': {
                    price: 99.99,
                    credit: 125
                },
            },
            openAI: {
                serviceCharges: {
                    fixed: 1,
                    usage: 2,
                    type: process.env.MIX_OPENAI_SERVICE_CHARGES_TYPE,
                    letterRewrite: process.env.MIX_OPENAI_SERVICE_CHARGES_LETTER_REWRITE,
                    chat: process.env.MIX_OPENAI_SERVICE_CHARGES_CHAT,
                }
            },
            trialDays: process.env.MIX_TRIAL_DAYS,
            purchase_type:ref(0)
        }
    },
    actions: {
        async fetchPlans() {
            try {
                const route = this.router.resolve(
                    {
                        name: 'billing-plans',
                    }
                );
                const $this = this;
                this.plans = await axios.post(route.href)
                .then(function (response) {
                    $this.isLoading = true;
                    $this.planData = response.data.data;
                    $this.salePlans = response.data.data.salePlans;
                    $this.yearEndPlans = response.data.data.yearEndPlans;
                    return response.data.data.plans;
                });
            } catch (error) {
                console.log(error);
            }
        },
        async fetchCoursesPlans() {
            try {
                const route = this.router.resolve(
                    {
                        name: 'courses-plans',
                    }
                );
                const $this = this;
                this.coursePlan = await axios.post(route.href)
                .then(function (response) {
                    $this.isLoading = true;
                    $this.planCourseData = response.data.data;
                    return response.data.data.plans;
                });
            } catch (error) {
                console.log(error);
            }
        },
        getPrice(type) {
            if (this.openAI.serviceCharges.type == this.openAI.serviceCharges.fixed) {
                return type == 'chat' ? this.openAI.serviceCharges.chat : this.openAI.serviceCharges.letterRewrite;
            }
        }
    },
    getters: {
        getPlan: (state) => {
            return (slug, key) => {
                if (state.plans) {
                    let listPlans = Array.isArray(state.plans) ? state.plans : Object.values(state.plans);
                    let plan = listPlans.find((plan) => {
                        if (plan.slug == slug) {
                            return plan;
                        }
                    });
                    return plan[key] ? plan[key] : null;
                }
                return null;
            }
        },
        getCoursesPlans:(state)=>{
            return (slug, key) => {
                if (state.coursePlan) {
                    let listPlans = Array.isArray(state.coursePlan) ? state.coursePlan : Object.values(state.coursePlan);
                    let coursePlan = listPlans.find((coursePlan) => {
                        if (coursePlan.slug == slug) {
                            return coursePlan;
                        }
                    });
                    return coursePlan[key] ? coursePlan[key] : null;
                }
                return null;
            }
        }
    },
})
